const formatTimeToHours = (time: string): string => {
  const [hours, minutes, seconds] = time.split(':').map(Number);
  if (hours > 0) {
    return `${hours}h`;
  } else if (minutes > 0) {
    return `${minutes}m`;
  } else {
    return `${seconds}s`;
  }
};

export default formatTimeToHours;